<script lang="ts">
    import Layout from "../components/ui/layout.svelte";   
    import { apiServer } from "../constant";
    import Button from "../components/basic/button.svelte";
    import { help_data, step_pointer, bam_host } from "../store";
    import { onMount } from "svelte";
    import * as animateScroll from "svelte-scrollto";

    onMount(async () => {
        window.scrollTo(0,0);
    });

    let scrollStepKey;
    step_pointer.subscribe((value) => {
        scrollStepKey = value;
        const ele = document.getElementById("right-container");
        if (ele) {
            window.scrollTo(0,0);
            ele.scroll({top: steps[scrollStepKey].scroll_height, behavior: "smooth"});
        }
        animateScroll.scrollTo({ element: `#${scrollStepKey}`});
    });


    let top_section = {};
    let steps = {};
    let bottom_section = {};
    let error = null;
    onMount(async () => {
        fetch(apiServer + '/api/howitworks?populate=howitworks.steps&populate=howitworks.top_section.video_preview&populate=howitworks.top_section.video&populate=howitworks.top_section.background1&populate=howitworks.top_section.background2&populate=howitworks.bottom_section.video_preview&populate=howitworks.bottom_section.video&populate=howitworks.bottom_section.background1&populate=howitworks.bottom_section.background2', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            top_section = data.data.attributes.howitworks.top_section[0];
            bottom_section = data.data.attributes.howitworks.bottom_section[0];
            data.data.attributes.howitworks.steps.forEach(step => {
                let contents = [];
                step.content.split("![").forEach(part => {
                    const image = part.substring(part.indexOf('](') + 2, part.indexOf(')'));
                    const text = part.substring(part.indexOf(')') + 1);
                    if (image.length > 3) {
                        contents.push({ type: 'image', body: image });
                    }
                    if (text.length > 3) {
                        contents.push({ type: 'text', body: text });
                    }
                });
                steps[step.identifier] = {...step, content: contents};
            });
            help_data.set({
                top_section: top_section,
                bottom_section: bottom_section,
                steps: steps
            });

            if (scrollStepKey) {
                setTimeout(() => {
                    const ele = document.getElementById("right-container");
                    ele.scroll({top: steps[scrollStepKey].scroll_height, behavior: "smooth"});
                }, 100);
            }
        })
        .catch(e => error = e);
    });

    let activeItem = 0
    $: handleActive

    const handleActive = (item) => {
        activeItem = item;
    }
</script>

<Layout>
    {#if (Object.keys(steps).length && Object.keys(top_section).length && Object.keys(bottom_section).length)}
        <div class="container">
            <div class="wrapper">
                <!-- Top Section -->
                <div class="title">{top_section['title'] ? top_section['title'] : ''}</div>
                <div class="description">{top_section['content'] ? top_section['content'] : ''}</div>
                <div class="divider" id="divider" />
                <div class="port-image">
                    <img
                        src={apiServer + ((top_section && top_section['background2'].data) ? top_section['background2'].data.attributes.url : '')}
                        alt={(top_section && top_section['background2'].data) ? top_section['background2'].data.attributes.alternativeText : ''}
                        class="port"
                    />
                </div>

                <!-- Steps -->
                <div class="body">
                    <div class="sidebar">
                        {#each Object.keys(steps) as step_key, i}
                            <div
                                class="item" 
                                on:click={() => {
                                    const ele = document.getElementById("right-container")
                                    ele.scroll({top: steps[step_key].scroll_height, behavior: "smooth"})
                                }}
                            >
                                <div class={`number ${i === activeItem && "active"}`}>{i + 1}</div>
                                <div class={`item-text ${i === activeItem && "active-text"}`}>{steps[step_key].step_title}</div>
                            </div>
                        {/each}
                        <img src="/images/lawn-mower.png" alt="motor" class="motor" />
                    </div>
                    <div 
                        class="right-container" 
                        id="right-container"
                        on:scroll={(e) => {
                            for (let i = 0; i < Object.keys(steps).length; i ++) {
                                if (i < Object.keys(steps).length - 1) {
                                    if (e.target['scrollTop'] < steps[Object.keys(steps)[i + 1]].scroll_height && e.target['scrollTop'] >= steps[Object.keys(steps)[i]].scroll_height) {
                                        handleActive(i)
                                        break
                                    }
                                } else {
                                    if (e.target['scrollTop'] >= steps[Object.keys(steps)[i]].scroll_height) {
                                        handleActive(i)
                                        break
                                    }
                                }

                            }
                        }}
                    >
                        {#each Object.keys(steps) as step_key, index}
                            <div class="mob-title" id={steps[step_key].identifier}>
                                <div class="item">
                                    <div class="number active">{index + 1}</div>
                                    <div class="item-text active-text">{steps[step_key].title}</div>
                                </div>
                            </div>
                            <div 
                                class="section"
                                id={steps[step_key].identifier}
                                style={
                                    `border-bottom-width: ${index === Object.keys(steps).length - 1 ? 0 : '1px'};`
                                }
                            >
                                <div class="sign-title">{steps[step_key].title}</div>
                                {#each steps[step_key].content as contentItem, contentIndex}
                                    <div class={`${contentItem.type}-container`}>
                                        {#if (contentItem.type === 'text')}
                                            <div class="sign-description">
                                                {contentItem.body}
                                            </div>
                                        {/if}
                                        {#if (contentItem.type === 'image')}
                                            <img
                                                src={apiServer + contentItem.body}
                                                alt={contentItem.body}
                                                class="signup-image"
                                            />
                                        {/if}
                                    </div>
                                {/each}
                                <div class="mob-down-anchor" id={index === Object.keys(steps).length - 1 ? "mob-title-analyze" : `mob-title-${steps[step_key].identifier}`} />
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom Section -->
        <div class="transform">
            <img
                src={apiServer + ((bottom_section && bottom_section['background1'].data) ? bottom_section['background1'].data.attributes.url : '')}
                alt={(bottom_section && bottom_section['background1'].data) ? bottom_section['background1'].data.attributes.alternativeText : ''}
                class="transform-motor"
            />
            <img
                src={apiServer + ((bottom_section && bottom_section['background2'].data) ? bottom_section['background2'].data.attributes.url : '')}
                alt={(bottom_section && bottom_section['background2'].data) ? bottom_section['background2'].data.attributes.alternativeText : ''}
                class="transform-port"
            />
            <div class="transform-title">{bottom_section['title']}</div>
            <div class="transform-description">{bottom_section['content']}</div>
            <div class="transform-items">
                {#each bottom_section['extra'] as item}
                    <div class="transform-item">
                        <div class="number active">
                            <img
                                src="/images_icon/check.svg"
                                alt="check"
                            />
                        </div>
                        <div class="transform-item-text">{item}</div>
                    </div>
                {/each}
            </div>
            <div class="drive-button">
                <Button title={bottom_section['button_text']} on_click_func={() => { window.location.href = $bam_host + '/Register_Plan?plan_type=free&domain_name=sample'; }} />
            </div>
            <div class="mob-motor">
                <img
                    src={apiServer + ((bottom_section && bottom_section['video_preview'].data) ? bottom_section['video_preview'].data.attributes.url : '')}
                    alt={(bottom_section && bottom_section['video_preview'].data) ? bottom_section['video_preview'].data.attributes.alternativeText : ''}
                    class="mob-motor-image"
                />
            </div>
        </div>
    {/if}
</Layout>
<style src="../styles/help.css">
</style>